/** A command sent from the server to the client. */
export enum ServerCommand {
  tableStart = "tableStart",
  init = "init",
  gameAction = "gameAction",
  gameActionList = "gameActionList",
  connected = "connected",
  clock = "clock",
  pause = "pause",
  noteListPlayer = "noteListPlayer",
  noteList = "noteList",
  note = "note",
  voteChange = "voteChange",
  cardIdentities = "cardIdentities",
  finishOngoingGame = "finishOngoingGame",
  replaySegment = "replaySegment",
  replayIndicator = "replayIndicator",
  replaySound = "replaySound",
  replayLeader = "replayLeader",
  suggestion = "suggestion",
  hypothetical = "hypothetical",
  hypoStart = "hypoStart",
  hypoEnd = "hypoEnd",
  hypoBack = "hypoBack",
  hypoAction = "hypoAction",
  hypoShowDrawnCards = "hypoShowDrawnCards",
  replayEfficiencyMod = "replayEfficiencyMod",
  boot = "boot",
  chat = "chat",
  chatTyping = "chatTyping",
  chatDelete = "chatDelete",
  chatList = "chatList",
  chatPMHistory = "chatPMHistory",
  error = "error",
  friends = "friends",
  game = "game",
  gameHistory = "gameHistory",
  gameHistoryFriends = "gameHistoryFriends",
  gameHistoryOtherScores = "gameHistoryOtherScores",
  name = "name",
  joined = "joined",
  left = "left",
  spectators = "spectators",
  table = "table",
  tableList = "tableList",
  tableGone = "tableGone",
  user = "user",
  userInactive = "userInactive",
  userLeft = "userLeft",
  userList = "userList",
  warning = "warning",
  maintenance = "maintenance",
  shutdown = "shutdown",
  soundLobby = "soundLobby",
  welcome = "welcome",
}
